module.exports = {
	nav: {
		home: 'Home',
		products: 'Products',
		solutions: 'Solutions',
		about: 'About Us',
		apply: 'Apply for trial',
		seeyi: 'See Extraordinary with Yi+ AI',
		watchVideo: 'Watch Video',
	},
	footer: {
		apply: 'Apply for trial',
		partnership: 'Partnership',
		business: 'Business',
		recruitment: 'Recruitment',
		media: 'Media',
		more: 'Learn More',
		products: 'Products',
		solutions: 'Solutions',
		about: 'About Us',
		follow: 'Follow Us',
		free:'Diversified Intelligence Platform, Try It Free',
		wechat: 'Yi+ Wechat',
		Moshanghua: 'Beijing Moshanghua Tech Co., LTD.',
		ICP: '京ICP备15061733号-1',
	},
	home:{
		provide:'We provide quality service to these international brands',
		More:'Learn More'
	},
	product: {
		Computer: 'Computer Vision Search Engine',
		Depth: 'Product Depth Modelling Search',
		depiction: 'The depiction of high-level semantic features and underlying image features increases our search ability for products. By leveraging on a large amount of product data on e-commerce sites, users can now use Yi+ CV engine to quickly find their product of interest. ',
		Recommendation: 'Accurate Product Recommendation',
		behaviour: 'Through the analysis of image and video content, as well as user behaviour, Yi+ provides\n' + 'accurate product recommendation.',
		Analysis: 'Product Detection and Category Analysis',
		massive: 'Using a massive amount of data for deep learning, Yi+ detects products in videos and images easily. We also analyse product features to determine their categories and support the detection of more than 100 categories, including apparels, 3C digital, supermarkets, home and daily necessities, transport vehicles and etc.',
		Image: 'Image and Video Data Structuralised Engine',
		Contour: 'Contour Segmentation',
		characteristics: 'Via the deep learning of object characteristics, Yi+ provides contour detection in videos and images.',
		Target: 'Target Detection',
		adopts:'Yi+ adopts the most advanced deep-learning based algorithm, which supports the target detection and identification of more than 300 commonly used objects.',
		General: 'General Object and Scene Recognition',
		supports: 'Yi+ supports the identification of more than 10,000 general purpose objects, as well as 400 indoor and outdoor scenes.',
		Face: 'Face Recognition and Analysis Engine',
		FaceRecognition: 'Face Recognition',
		RealTime: 'Real-time detection of faces in video and images.\n' + 'Can be used in cameras, live broadcasts and other scenes.',
		Characteristic: 'Characteristic Analysis',
		identifies: 'Yi+ identifies a person’s gender, age, race, mood, attractiveness and fashion values in images and videos, with an average accuracy of over 90%. \n' + 'The average age prediction error is less than 3 years old.',
		FaceComparison: 'Face Comparison',
		Facial: 'Facial similarity measurement based on deep-learning face recognition technology\n' + 'Can be used for face clustering, sensitive person monitoring and other scenes.',
		Points: 'Key Points Detection',
		Supports: 'Supports the detection of more than 200 facial key points, such as eyes, nose and mouth contours. Positioning can be adapted to changes in facial movements.',
	},
	solution:{
		Excavating:'Excavating Traffic Entrances for Smart Media and Marketing ',
		Industry:'Yi+AI Industry Solutions',
		Marketing:'Marketing + AI',
		Intelligent:'Intelligent Marketing Solutions',
		Effective:'Effective marketing should focus on high-content advertisement exposure and content recommendation. Yi+ AI technology makes intelligent marketing possible.',
		Relevant:'Relevant application areas to consider',
		Advertisers:'Advertisers',
		Advertising:'Advertising Media',
		Video:'Video Sites/App',
		Livestream:'Livestream',
		Short:'Short Videos',
		Browsers:'Browsers',
		Search:'Search Engines',
		Platforms:'Image Platforms',
		Structured:'Structured Classification of Image and Video Data',
		Scenario:'Scenario-based Advertising Solution',
		ImageSearch:'Image Search for Similar Items',
		SearchByImage:'Search-by-Image',
		Personalized:'Personalized Recommendation via Information Stream',
		Face:'Face Recognition Advertisements',
		Television:'Television + AI',
		Communication:'Intelligent Communication Solutions',
		propelled:'The dawn of the AI age has propelled digital transformation trends in media and entertainment. Be prepared for a more dynamic and explosive content marketing with the introduction of Yi+AI smart TV!',
		Smart:'Smart TV',
		Assistant:'TV AI Assistant',
		Televised:'Televised Scenario-based Advertising Solution',
		Valueadded:'Value-added Live-streaming Advertising',
		Extraction:'Content Extraction and Video Clip Synthesis',
		Broadcasting:'Broadcasting Safety and Control',
		CameraAi:'Camera + AI',
		Creative:'Creative-Interactive Solutions',
		future:'The future of smart camera will be even more interactive with Yi+ AI technology to record your precious moments!',
		Camera:'Camera',
		Photo:'Photo Album App',
		SmartPhoto:'Smart Photo Album',
		Virtual:'Virtual Makeup',
		Dynamic:'Dynamic AR Camera',
		Shopping:'Photo-Shopping',
		Realtime:'Real-time Scene and Object Recognition',
	},
	about: {
		Intelligently:'See Intelligently',
		Extraordinary:'See Extraordinary',
		Contact:'Contact Us',
		Join:'Join us',
		intro: 'As one of the world’s leading computer vision engine provider, Yi+ (Beijing Moshanghua Tech Co., Ltd.) offers business enterprises with intelligent and commercialized visual content solutions. We strive to harness the value hidden in large amounts of visual information.Our two flagship brands are Yi+, which is an artificial intelligence computer vision engine and Dress+, a search-by-image fashion app. We have achieved the peak of excellence in image and video applications for scenario-based, general object, product and facial detection, recognition, search and recommendation technologies. Under Yi+, we offer three industry solutions, namely “Marketing+ AI”, “TV+AI” and “Camera + AI”. Our applications spanned across media platforms, smart TV, smart camera and etc. We have served more than 400 million users via our data-structured products based on visual identification technology that has enabled media providers to realize intelligent analysis, content interaction and scene marketing.',
		media: 'Media Reports',
		china: 'CHINA',
		chinaAdds: 'SOHO 3Q, 6 Danling St.,',
		chinabeijing: 'Haidian, Beijing',
		USA:'USA',
		SINGAPORE: 'SINGAPORE',
	}
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js